import React from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';

import logo from '../images/polymedia-citrus.png';
import config from '../config.js';

import {fetchDataIfReady, fetchDataIfUndefined} from 'Skelet/src/modules/fetch.action.js';
import {handleChange} from 'Skelet/src/modules/functions.js'


class Feedback extends React.Component {

  constructor(props) {
    super(props);

    let embed_interface = false;
    let poll_language = "NL";
    if(typeof URLSearchParams === "function") {
      let params = new URLSearchParams(this.props.location.search);
      let param_embed = params.get('embed');
      let param_lang = params.get('lang');
      if(param_embed === "") {
        embed_interface = true;
      }
      if(param_lang && param_lang.trim() !== "" && param_lang.toLowerCase() === "en") {
        poll_language = "EN";
      }
    }
    document.documentElement.setAttribute('lang', poll_language.toLowerCase());

    this.state = {
      disabled: false,
      embed_interface,
      poll_language,
      stars:5,
      text:"",
      email:""
    };
  }

  componentWillMount() {
  }

  componentWillReceiveProps(nextProps) {
  }

  render() {
    const poll_language = this.state.poll_language;

    document.title = "Citrus Poll · Feedback Widget · Citrus by Polymedia";

    let header = "Geef feedback";
    let stars_text = "Hoeveel sterren geef je deze website?";
    let stars = "sterren";
    let star = "ster";
    let text_text = "Type jouw feedback.";
    let text = "Type hier..";
    let email_text = "Jouw e-mail adres.";
    let email = "voorbeeld@website.nl";
    if(poll_language === "EN") {
      header = "Give feedback";
      stars_text = "How many stars do you give this website?";
      stars = "stars";
      star = "star";
      text_text = "Type your feedback.";
      text = "Type here..";
      email_text = "Your email address.";
      email = "example@website.com";
    }

    import('../poll.css');
    return (
      <div>
        <div style={(!this.state.embed_interface) ? {padding:"1em", background:"#f5f5f5", minHeight:"100vh"} : null}>
          <div className="poll" style={(!this.state.embed_interface) ? {margin:"2em auto", maxWidth:"700px"} : null}>
            <div className="poll-header"><div>{header}</div><div style={(!this.state.embed_interface) ? {display:"none"} : null}><a href="https://citrus.polymedia.nl/" target="_blank" rel="noopener noreferrer"><img src={logo} alt="Citrus by Polymedia" /></a></div><br style={{clear:"both"}}/></div>
            <form>
              <div className="poll-body feedback">
                <p><i/>{stars_text}</p>
                <select value={this.state.stars} onChange={(e) => handleChange(this, "stars", e)} style={{marginBottom:"26px"}}>
                  <option key={"o1"} value="5">5 {stars}</option>
                  <option key={"o2"} value="4">4 {stars}</option>
                  <option key={"o3"} value="3">3 {stars}</option>
                  <option key={"o4"} value="2">2 {stars}</option>
                  <option key={"o5"} value="1">1 {star}</option>
                </select>
                <p><i/>{text_text}</p>
                <textarea value={this.state.text} onChange={(e) => handleChange(this, "text", e)} maxLength="240" placeholder={text} style={{marginBottom:"26px"}}/>
                <p><i/>{email_text}</p>
                <input type="text" value={this.state.email} onChange={(e) => handleChange(this, "email", e)} maxLength="120" placeholder={email}/>
              </div>
              <div className="poll-footer">
                {poll_language === "NL" && !this.state.disabled && <button onClick={() => this.confirm()} className="selected" style={{border:"0"}}>Verstuur</button>}
                {poll_language === "EN" && !this.state.disabled && <button onClick={() => this.confirm()} className="selected" style={{border:"0"}}>Send</button>}
                {poll_language === "NL" && this.state.disabled && <span>Bedankt voor jouw feedback!</span>}
                {poll_language === "EN" && this.state.disabled && <span>Thank you for your feedback!</span>}
              </div>
            </form>
          </div>
          {!this.state.embed_interface && <div className="logo-footer"><a href="https://citrus.polymedia.nl/" target="_blank" rel="noopener noreferrer"><img src={logo} alt="Citrus by Polymedia" /></a></div>}
        </div>
      </div>
    );
  }


  /* The navigator.cookieEnabled property returns true if cookies are enabled, otherwise false:
  console.log(navigator.userAgent);
  console.log(navigator.vendor);
  var url = (window.location !== window.parent.location)
  ? document.referrer
  : document.location.href;
  // if url === "" : maybe Edge?
  console.log(url);*/
  confirm() {
    if(!this.state.disabled) {
      let ref_id = this.props.match.params.id;
      this.props.fetchDataIfReady(config.api_token, "bin", "POST", config.api_url+"/feedback", JSON.stringify({id:ref_id, stars:this.state.stars, text:this.state.text, email:this.state.email}), null, true);
      this.setState({disabled:true});
    }
  };

}


function mapStateToProps(state) {
  return {
    apiData: state.apiData,
  }
}

function mapDispatchToProps(dispatch){
  return bindActionCreators({
    fetchDataIfReady,
    fetchDataIfUndefined,
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(Feedback)



// WEBPACK FOOTER //
// ./src/containers/Feedback.js